import { InMemoryCache } from '@apollo/client'

import { generateClient } from './_config/generateClient'

export const cache = new InMemoryCache()

export const sessionsClient = generateClient('sessions', cache)
export const accountsClient = generateClient('accounts', cache)
export const cacheClient = generateClient('cache', cache)
export const checklistsClient = generateClient('checklists', cache)
export const placesClient = generateClient('places', cache)
export const segmentsClient = generateClient('segments', cache)
export const serviceOrdersClient = generateClient('service-orders', cache)
export const qrcodesClient = generateClient('qrcodes', cache)
export const formsClient = generateClient('forms', cache)
export const minicrudsClient = generateClient('minicruds', cache)
export const triggersClient = generateClient('triggers', cache)
export const templatesClient = generateClient('templates', cache)
export const documentsClient = generateClient('documents', cache)
export const compliancesClient = generateClient('compliances', cache)
export const generalClient = generateClient('general', cache)
export const fieldsClient = generateClient('fields', cache)
export const analyticsClient = generateClient('analytics', cache)
export const importsClient = generateClient('imports', cache)
export const exportsClient = generateClient('exports', cache)
export const mapPointsClient = generateClient('map-points', cache)
export const mapPointsHistoryClient = generateClient('map-points-history', cache)
export const integrationsClient = generateClient('integrations', cache)
export const campaignsClient = generateClient('campaigns', cache)
export const auditClient = generateClient('audits', cache)
export const stocksClient = generateClient('stocks', cache)
